import axios from '../../services/axios';

const BASE = '/practical-challenges';
const unwrap = (res) => res.data.data;

export const challengeApi = {
    list: () => axios.get(BASE).then(unwrap),
    get: (id) => axios.get(`${BASE}/${id}`).then(unwrap),
    save: (id, answers) => axios.put(`${BASE}/${id}/submission`, { answers }).then(unwrap),
    submit: (id, answers) => axios.post(`${BASE}/${id}/submission/submit`, { answers }).then(unwrap),
    recall: (id) => axios.post(`${BASE}/${id}/submission/recall`).then(unwrap),
    upload: (id, fieldKey, file) => {
        const form = new FormData();
        form.append('field_key', fieldKey);
        form.append('file', file);
        return axios.post(`${BASE}/${id}/files`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 120000
        }).then(unwrap);
    },
    setFieldConsent: (id, fieldKey, consent) =>
        axios.patch(`${BASE}/${id}/fields/${encodeURIComponent(fieldKey)}/consent`, { consent }).then(unwrap),
    setFileConsent: (fileId, consent) => axios.patch(`${BASE}/files/${fileId}`, { consent }).then(unwrap),
    deleteFile: (fileId) => axios.delete(`${BASE}/files/${fileId}`).then(unwrap),
    fileBlob: (fileId) => axios.get(`${BASE}/files/${fileId}`, { responseType: 'blob' }).then((res) => res.data)
};

export const reviewApi = {
    queue: (params) => axios.get(`${BASE}/reviews`, { params }).then(unwrap),
    get: (submissionId) => axios.get(`${BASE}/reviews/${submissionId}`).then(unwrap),
    comment: (submissionId, body) => axios.post(`${BASE}/reviews/${submissionId}/comments`, body).then(unwrap),
    deleteComment: (submissionId, commentId) =>
        axios.delete(`${BASE}/reviews/${submissionId}/comments/${commentId}`).then(unwrap),
    decide: (submissionId, body) => axios.post(`${BASE}/reviews/${submissionId}/decision`, body).then(unwrap),
    nudge: (body) => axios.post(`${BASE}/reviews/nudge`, body).then(unwrap)
};

export const builderApi = {
    list: () => axios.get(`${BASE}/manage/challenges`).then(unwrap),
    get: (id) => axios.get(`${BASE}/manage/challenges/${id}`).then(unwrap),
    create: (body) => axios.post(`${BASE}/manage/challenges`, body).then(unwrap),
    update: (id, body, publish) =>
        axios.put(`${BASE}/manage/challenges/${id}`, body, {
            params: publish === undefined ? {} : { publish: String(publish) }
        }).then(unwrap),
    archive: (id) => axios.delete(`${BASE}/manage/challenges/${id}`).then(unwrap)
};

/** Server message for a failed request, with the submission problems if any. */
export function errorMessage(error, fallback = 'Something went wrong') {
    return error?.response?.data?.message || fallback;
}
